import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  PLATFORM_ID,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { SkeletonService } from '../shared/services/skeleton.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { SlickCarouselComponent } from 'ngx-slick-carousel/slick.component';
import { ApiService } from '../shared/services/apiService.service';
import { Subscription, forkJoin } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { secureStorage } from '../shared/services/encryption/secureservice';
import { BreadcrumbComponent } from '../shared/components/breadcrumb/breadcrumb.component';
import { environment } from '../../environments/environment';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ConfLobControlService } from '../configurator-app/Conf-Shared/Services/conf-lob-service/conf-lob-control.service';
import { BehaviourSubjectService } from '../shared/services/behaviour-subject.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SeoService } from '../shared/seo/seo.service';
declare let ONE3D: any;
var $ = require('jquery');

@Component({
  selector: 'app-brandpage',
  templateUrl: './brandpage.component.html',
  styleUrls: ['./brandpage.component.scss'],
})
export class BrandpageComponent implements OnInit {
  @ViewChild('slickHLModal1') slickModal1: SlickCarouselComponent;
  @ViewChild(BreadcrumbComponent) breadCrumb: BreadcrumbComponent;
  @ViewChild('content', { static: true }) content: any;
  @Output() showModel = new EventEmitter();
  sub: Subscription = new Subscription();
  _3dPostSubscription: any = new Subscription();
  environment1 = environment.s3bucket.url;
  confAWSUrlStr: any = environment.confAWSurl;
  cfrnt_url: string;
  newFuelType: any;
  breadcrumbdata: any[];
  showBreadCrumb: boolean = false;
  loBname:any
  breadcrumbList: {
    label: any;
    url: string;
    pageName: string;
  };
  imageURLs: any = [];
  varientImg: { images: { image_url: string }[] } = { images: [] };
  varImg: any = [];
  brandType: string;
  vehicleNumber: any = [];
  lob: any;
  ppl: any[]=[];
  sub_lob;
  brand: any;
  height: number=0;
  width: number=0;
  isMobile: boolean;
  exactProduct: any;
  pl:any;
  metatitle = 'Buy Tata Trucks and Buses Online in India - Tata Motors';
  metadesc =
    'Enquire, book and buy online Tata Ace, Intra, Yodha Pickup, Winger, Magic, Signa, Prima, Ultra, and entire Truck, Tipper, Bus range with Tata Motors authorized dealers.';
  newlob: any;
  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    public skeletonService: SkeletonService,
    private apiService: ApiService,
    private localStorage: secureStorage,
    private route: ActivatedRoute,
    config: NgbModalConfig,
    private modalService: NgbModal,
    private _dataLobService: ConfLobControlService,
    private behaviorService: BehaviourSubjectService,
    private spinner: NgxSpinnerService,private seoservice: SeoService

  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  videoData: any[] = [];
  clickModal: any = 0;
  showModalButton: boolean = false;
  lightClick = 0;
  imageUrls: any = [];
  activeVariantIndex: number | null = null;
  heartUrls = {
    empty: "assets/images/Star-unfilled.svg",
    half: "assets/images/Star-unfilled.svg",
    full: "assets/images/Star-filled.svg"
  };
  activeVariantStyle = {};
  defaultVariantIndex: number = 0;
  customOptionsForBanner: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 1200,
    autoplay: true,
    responsiveRefreshRate: 1000000,

    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      740: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
  };
  contentLoaded: any;
  customOptions1: OwlOptions = {
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    margin: 14,
    navText: [
      `<img alt="left" src=${this.environment1}assets/images/c-arrow-left.svg>`,
      `<img alt="right" src=${this.environment1}assets/images/c-arrow-right.svg>`,
    ],
    responsive: {
      0: {
        items: 1.3,
      },
      400: {
        items: 2,
      },
      600: {
        items: 3,
      },
      940: {
        items: 4,
      },
    },
    nav: true,
  };
  popimageSlider = {
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024, // Breakpoint for tablets (768px)
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          // Other tablet-specific settings...
        },
      },
      {
        breakpoint: 480, // Breakpoint for mobile devices (480px)
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // Other mobile-specific settings...
        },
      },
    ],
  };
  firstslider = {
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
  //   arrows: true,
  //   prevArrow:
  //   '<button class="slick-prev"><img alt="right" style="margin: -25px;" src="https://d3bslevwxw022c.cloudfront.net/buytrucknbus-tatamotors-com/cv/cv_online/assets/images/c-arrow-left.svg"></button>',
  // nextArrow:
  //   '<button class="slick-next" id="nexslide"><img alt="right"  style="margin: -25px;" src="https://d3bslevwxw022c.cloudfront.net/buytrucknbus-tatamotors-com/cv/cv_online/assets/images/c-arrow-right.svg"></button>',
  // asNavFor: '.thumbs',
    responsive: [
      {
        breakpoint: 480, // Breakpoint for mobile devices (480px)
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          // Other mobile-specific settings...
        },
      },
    ],
  };
  secondslider = {
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      '<button class="slick-prev"><img alt="right" style="margin: -25px;" src="https://d3bslevwxw022c.cloudfront.net/buytrucknbus-tatamotors-com/cv/cv_online/assets/images/c-arrow-left.svg"></button>',
    nextArrow:
      '<button class="slick-next" id="nexslide"><img alt="right"  style="margin: -25px;" src="https://d3bslevwxw022c.cloudfront.net/buytrucknbus-tatamotors-com/cv/cv_online/assets/images/c-arrow-right.svg"></button>',
    asNavFor: '.thumbs',
    arrows: true,
  };
  changeallslides: boolean = false;
  show3dModel: boolean = false;
  showModalType: any = '';
  column_Five:any;
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.height = window.innerHeight;
      this.width = window.innerWidth
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }

    }
    this.route.paramMap.subscribe((params) => {
      this.brandType = params.get('brandType');

      this.fetchBannerData();
      this.changeallslides = true;
      this.fetchBannerVideoData();
      this.lob;
      this.ppl=[];
      // this.brand;
      setTimeout(() => {
        this.breadcrumb();
      }, 1000);
    });
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  closeModal() {
    this.modalService.dismissAll();
  }
  fetchBannerData() {
    const requestData = {
      page: 'BRAND',
      brand_type: this.brandType,
      offset: 0,
      size: 6,
      source:this.isMobile ? 'webapp':'web'
    };
    this.spinner.show();
    this.apiService.getBannerData(requestData).subscribe({
      next: (res) => {
        if (res.success) {
          this.cfrnt_url = res.cfrnt_url
          this.imageUrls = res.data;

        }
        else{
          this.imageUrls = [];
        }
        this.spinner.hide();
      },
      error: (err) => {
        console.error('Error fetching banner data', err);
        this.spinner.hide();
      },
    });
  }


  fetchBannerVideoData() {
    const requestData = {
      category: 'BRAND',
      title: this.brandType,
    };
    this.spinner.show();
    this.apiService.getBannerVideoData(requestData).subscribe({
      next: (res) => {
        if (res.success) {
          this.videoData = res.data.banner_data;
          this.vehicleNumber = res.data.banner_data[0].default_vc;
          this.sub_lob = res.data.banner_data[0].sub_lob;
          // this.ppl = res.data.banner_data[0].ppl;
          this.lob = res.data.banner_data[0].lob;

          const variantdata = res?.data?.banner_data[0]?.variant_data;
            const parsedData = JSON.parse(variantdata)
          this.varImg = parsedData.data
           this.varImg.filter((e:any)=>{
            let data = e.level4_ppl_actual_name
            this.ppl.push(data)
          });
          this.getCarouselData(this.varImg[0],0)
          const defaultVariant = this.varImg[this.defaultVariantIndex];
            this.activeVariantIndex = this.defaultVariantIndex;
            this.activeVariantStyle = { background: 'rgb(48, 127, 226)' };
          this.newFuelType = {
            images: res.data.product_data.map((product) => product.images),
          };
          this.getVehiclefuelDetail(defaultVariant.default_vc);
          this.getButtonVisible(defaultVariant.default_vc);
          this.breadcrumb();
        }
        this.spinner.hide();
      },
      error: (err) => {
        console.error('Error fetching banner data', err);
        this.spinner.hide();
      },
    });
  }
  breadcrumb() {
    localStorage.removeItem('localBreadCrumb');
    this.breadcrumbdata = [];
    var breadcrumbList1 = {
      label: this.sub_lob,
      url: `/brand/`,
    };
    var breadcrumbList2 = {
      label: this.brandType,
      url: `/brand/${this.brandType}`,
    };
    this.breadcrumbdata.push(breadcrumbList1, breadcrumbList2);

    this.localStorage.setItem(
      'localBreadCrumb',
      JSON.stringify(this.breadcrumbdata)
    );
    this.showBreadCrumb = true;
    this.seoservice.callSchema();
  }

  getButtonVisible(vehicleNumber: any) {
    let _3dData: any = {};
    (_3dData['output_type'] = 'all'), (_3dData['vc_no'] = vehicleNumber);
    (_3dData['lob_name'] = this.newlob?.toLowerCase()), (_3dData['pl'] = this.pl);
    this._3dPostSubscription = this._dataLobService
      .getLobFilterData('osp_configurator_3d_image_filter', _3dData)
      .subscribe((res: any) => {
        if (res['RESPONSE']['STATUS_CODE'] == 200) {
          if (res['RESPONSE']['DATA']?.length > 0) {
            this.loBname=res?.RESPONSE?.DATA[0]?.lob?.toLowerCase();
            this.showModalButton = true;
          } else {
            this.showModalButton = false;
          }
        } else {
          this.showModalButton = false;
        }
      });
  }
getCarouselData(product: any, index: number) {
  if (this.activeVariantIndex !== null && this.activeVariantIndex !== index) {
    this.activeVariantStyle = {};
  }
  // Set the new active variant style
  this.activeVariantStyle = {
    background: 'rgb(48, 127, 226)'
  };
  this.activeVariantIndex = index;
  this.exactProduct=product

  this.getVehiclefuelDetail(product.default_vc);
  this.getButtonVisible(product.default_vc);
}

  ViewProductList(item: any) {

    const activeVariant = this.varImg[this.activeVariantIndex];


    let clickedVariantData: any = {
      level4_ppl_actual_name: activeVariant.level4_ppl_actual_name
      // Add any other relevant data from the active variant
    };
    this.behaviorService.BrandSCVpic(activeVariant);

    if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem('ClickedVariant', JSON.stringify(clickedVariantData));
      localStorage.removeItem("ExploreMappedData")
      localStorage.removeItem("ExploreMappedData1")
      localStorage.removeItem("explore")
      localStorage.removeItem("EModeldData")
      localStorage.removeItem('ExploreMappedDatatype')
      localStorage.removeItem('ExploreMappedDatamodal')
    }
    const pplLowerCase =clickedVariantData.level4_ppl_actual_name == 'Winger' ? this.exactProduct?.level4_pl.replace(/[\s\/-]+/g, '-')?.toLowerCase() : clickedVariantData.level4_ppl_actual_name.replace(/[\s\/-]+/g, '-')?.toLowerCase();
    this.behaviorService.RoutefromBrand.next('brandpage');
    localStorage.removeItem('sideFilter')
    localStorage.removeItem("ExploreMappedData")
    localStorage.removeItem("ExploreMappedData1")
    localStorage.removeItem('ExploreMappedDatatype')
    localStorage.removeItem('ExploreMappedDatamodal')

      localStorage.removeItem('totalNoOfRecords')
      localStorage.removeItem('uniqueId')
      localStorage.removeItem('searchValue')
      localStorage.removeItem('filterValue');
      localStorage.removeItem('unbxFilterValue');
      this.behaviorService.filterValue.next('Header')
      this.behaviorService.isUnbxFilterChange.next(false)
      this.behaviorService.isSearch.next(false)
      this.behaviorService.callPlp.next(false)
      this.behaviorService.isClearfilter.next(false);
      // let brand=this.newFuelType.brand == null ? 'Winger':this.newFuelType.brand
      let wingerBrand=clickedVariantData.level4_ppl_actual_name == 'Winger' ? true :false;
      let magicBrand=clickedVariantData.level4_ppl_actual_name == 'Magic'? true :false;

      if (wingerBrand) {
        this.router.navigate(['/product-list', pplLowerCase]);
      }
      else if(magicBrand){
        this.router.navigate(['/product-list', pplLowerCase, this.newFuelType.column_five,'brand','type']);
      }
      else{
        this.router.navigate(['/product-list',this.newFuelType.brand, pplLowerCase]);
      }

  }
  getVehiclefuelDetail(vehicleNumber) {
    let data = {
      vehicle_number: vehicleNumber,
    };
    this.spinner.show();
    this.apiService.getVehicleDetails(data).subscribe({
      next: (res) => {
        if (res.success) {
          this.pl=''
          this.newFuelType = res?.data;
          this.brand=""
          this.brand = res?.data?.brand
          this.varientImg = res?.data;
          this.column_Five=res?.data?.column_five
          const pl=res.data.pl;
          this.pl=pl;
          let lobValue = '';
          switch (this.newFuelType.lob) {
            case 'hcv-const':
            case 'hcv-cargo':
              case 'HCV Const':
                case 'HCV Cargo':
              lobValue = 'hcv';
              break;
            case 'bus':
              case 'BUSES':
                case 'Buses':
              lobValue = 'bus';
              break;
            case 'magic':
              lobValue = 'tata_magic';
              break;
            case 'winger':
              case 'SCPASS':
              lobValue = 'winger';
              break;
            case 'hcv':
              lobValue = 'hcv';
              break;
            case 'ilmcv':
              lobValue = 'ilmcv';
              break;
            case 'scv':
              case 'SCV CARGO':
              lobValue = 'scv';
              break;
            case 'ScPass':
              lobValue = 'winger';
              break;
            case 'SCVPass':
              lobValue = 'tata_magic';
              break;
            case 'SCV Cargo':
              lobValue = 'scv';
              break;
            case 'Pickups':
              case 'PICKUPS':
            case 'Yodha & Intra':
              lobValue = 'scv';
              break;
            case 'mcv-trucks':
            case 'icv':
            case 'mhcv':
              case 'MCV Trucks':
                case 'ICV Trucks':
                case 'LCV':
              lobValue = 'ilmcv';
              break;
            default:
              lobValue = this.newFuelType.lob; 
              break;
          }
          this.newlob = lobValue;

         this.getButtonVisible(vehicleNumber);
          this.metatitle=res?.data?.vc_title  ? res?.data?.vc_title : 'Tata Motors Online Sales';
          this.metadesc=res?.data?.vc_description ? res?.data?.vc_description : '';
        }
        this.spinner.hide();
      },
      error: (err) => {
        console.error('Error fetching banner data', err);
        this.spinner.show();
      },
      complete: () => {
        this.seo();
      },
    });
  }

  open360View(content) {
    this.modalService.open(this.content, {
      size: 'lg',
      centered: true,
      windowClass: 'modal-xl',
    });
    return (this.show3dModel = true);
  }

  getVideoId(url: string): string {
    const videoId = url.split('v=')[1];
    const ampersandPosition = videoId.indexOf('&');
    if (ampersandPosition !== -1) {
      return videoId.substring(0, ampersandPosition);
    }
    return videoId;
  }
  GetTest(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      let url;
      var dataUrl = data.banner_link;
      if (dataUrl) {
        url = dataUrl?.replace(window.location.origin + '/' + dataUrl);
      }
    }
  }
  prevSlide() {
    this.slickModal1.slickPrev();
  }
  nextSlide() {
    this.slickModal1.slickNext();
  }



  show_model_view(event: any) {
    this.showModel.emit(false);
    this.showModalType = event;
    this.show3dModel = !this.show3dModel;
    this.clickModal++;

    if (this.lightClick % 2 == 1) {
      $('.conf-light-img').removeClass('conf-light-active');
      $('.conf-light-img img').attr(
        'src',
        `${this.confAWSUrlStr}/common/light_unselected.svg`
      );
      this.lightClick++;
      ONE3D.toggleLights();
    }
  }

  openProduct(data: any) {
    let sublob = (
      data.sub_lob == 'SCV Pickups'
        ? 'scv-pickups'
        : data.sub_lob == 'Icv Trucks'
        ? 'trucks'
        : data.sub_lob
    )?.toLowerCase();
    let lob = data.lob.replace(/\s/g, '-')?.toLowerCase();
    let ppl = data.ppl_seo;
    let pl = data.pl.replace(/\s/g, '-')?.toLowerCase();
    var url =
      '/product-details/' +
      sublob +
      '/' +
      lob +
      '/' +
      ppl +
      '/' +
      pl +
      '/' +
      data.id;
    return url;
  }
    seo() {
      this.seoservice.updateTitle(this.metatitle);
      this.seoservice.updateMetaTag('description', null, this.metadesc);
      this.seoservice.updateMetaTag(null, 'og:locale', 'en_US');
      this.seoservice.updateMetaTag(null, 'og:type', 'Website');
      this.seoservice.updateMetaTag(null, 'og:title', this.metatitle);
      this.seoservice.updateMetaTag(null, 'og:description', this.metadesc);
      this.seoservice.updateMetaTag(
        null,
        'og:url',
        environment.baseUrl + this.router.url
      );
      this.seoservice.updateMetaTag(null, 'og:site_name', 'Tata OSP');
      // this.seoservice.updateMetaTag(
      //   null,
      //   'og:image',
      //   'https://bookonline.tatamotors.com/cv/cv_online/VehicleImages/50852148000R/LPT-2818-Cowl.webp'
      // );
      this.seoservice.updateMetaTag(null, 'og:image:width', '1200');
      this.seoservice.updateMetaTag(null, 'og:image:height', '628');
    }
}
